/* eslint-disable no-unused-vars */
import {
  Table,
  Button,
  Input,
  Modal,
  Select,
  Row,
  Col,
  Form,
  Tooltip,
} from "antd";
import { useState, useRef } from "react";
import "./contactStyles.css";
import { DeleteTwoTone } from "@ant-design/icons";
// import { Form, Input, Select, Row, Col, Button } from 'antd';
import EditableImage from "../icons/EditIcon";

const { Option } = Select;
const ContactsTable = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const onFinish = (values) => {
    //console.log("Form values:", values);
  };
  const formRef = useRef();
  const handleRowClick = () => {};
  const record = null;
  const dataSource = [
    {
      key: "1",
      firstName: "John",
      lastName: "Doe",
      phone: "555-1234",
      email: "john.doe@example.com",
      status: "Active",
    },
    {
      key: "2",
      firstName: "Jane",
      lastName: "Doe",
      phone: "555-5678",
      email: "jane.doe@example.com",
      status: "Inactive",
    },
  ];

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Actions",
      key: "actions",
      render: () => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <EditableImage
            handleRowClick={handleRowClick}
            record={record}
            title="edit"
          />
          <DeleteTwoTone
            style={{
              cursor: "pointer",
              fontSize: "1.8rem",
              marginLeft: "0.9rem",
            }}
            title="delete"
            twoToneColor="#eb2f96"
          />
        </div>
      ),
    },
  ];
  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpen(false);
    formRef.current.resetFields();
  };
  const showModal = () => {
    setOpen(true);
  };
  const handleReset = () => {
    formRef.current.resetFields();
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          borderTop: "2px solid #D3D3D3",
          paddingTop: "2rem",
        }}
      >
        <div className="search-container">
          <div className="heading-text">
            CONTACTS |{" "}
            <span className="gold-text-span">
              {dataSource.length} contact(s)
            </span>
          </div>
          <div className="other-icons">
            <Tooltip title="Reset Filters">
              <div
                style={{
                  backgroundColor: "gray",
                  width: "24px",
                  height: "24px",
                  padding: "2px",
                  marginLeft: "1rem",
                  borderRadius: "5px",
                  cursor: "pointer",
                  display: "flex",
                }}
                // onClick={ResetFields}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path
                    d="M451-122q-123-10-207-101t-84-216q0-77 35.5-145T295-695l43 43q-56 33-87 90.5T220-439q0 100 66 173t165 84v60Zm60 0v-60q100-12 165-84.5T741-439q0-109-75.5-184.5T481-699h-20l60 60-43 43-133-133 133-133 43 43-60 60h20q134 0 227 93.5T801-439q0 125-83.5 216T511-122Z"
                    fill="white"
                  />
                </svg>
              </div>
            </Tooltip>
          </div>
        </div>

        <Input.Search
          className="search-input"
          placeholder="Search by..."
          enterButton
          //   onChange={(e) => search(e.target.value)}
        />
        <Button
          type="primary"
          htmlType="button"
          className="add-new-btn-contact"
          onClick={showModal}
        >
          + Add New
        </Button>
      </div>

      <Table
        size="small"
        dataSource={dataSource}
        columns={columns}
        bordered
        className="contacts-table"
      />
      <Modal
        title={<p className="modal-heading">ADD NEW CONTACT DETAILS</p>}
        centered
        // open={modalOpen}
        // onOk={() => setModalOpen(false)}
        // onCancel={() => setModalOpen(false)}
        onOk={handleOk}
        onCancel={handleCancel}
        open={open}
        footer={[]}
      >
        <Form onFinish={onFinish} style={{ marginTop: "3rem" }} ref={formRef}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="firstName"
                label={<span className="modal-text">First Name</span>}
                rules={[
                  { required: true, message: "Please enter your first name" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="lastName"
                label={<span className="modal-text">Last Name</span>}
                rules={[
                  { required: true, message: "Please enter your last name" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="phone"
                label={<span className="modal-text">Phone no. </span>}
                rules={[
                  { required: true, message: "Please enter your phone number" },
                  { pattern: /^[0-9]*$/, message: "Please enter only numbers" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="status"
                label={<span className="modal-text">Status</span>}
                rules={[{ required: true, message: "Please select a status" }]}
              >
                <Select>
                  <Option value="active">Active</Option>
                  <Option value="inactive">Inactive</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="email"
            label={<span className="modal-text">Email</span>}
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input />
          </Form.Item>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              height: "2rem",
            }}
          >
            <Form.Item style={{ marginRight: "1rem" }}>
              <Button key="back" onClick={handleCancel}>
                Cancel
              </Button>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default ContactsTable;
